import React from "react";
import PropTypes from "prop-types";
import RegisterForm from "../../components/register-form";
import ContactInfo from "../../components/contact-info";
import ContactData from "../../data/contact.json";

const RegisterContainer = ({ contRef }) => {
    return (
        <section className="contact-section section-py" ref={contRef}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-7 col-lg-7 mb-7">
                        <div className="contact-title-section text-center">
                            <h3 className="title g-color">
                                Fill the below registration form
                            </h3>
                            {/* <p className="b-color">
                                Hassle-free process
                                <br className="d-none d-xl-block" />
                            </p> */}
                        </div>

                        <RegisterForm />
                    </div>

                    <div className="col-xl-4 col-lg-4 mb-7 offset-xl-1">
                        <div className="contact-address text-center">
                            {ContactData &&
                                ContactData.map((single, key) => {
                                    return (
                                        <ContactInfo key={key} data={single} />
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

RegisterContainer.propTypes = {
    contRef: PropTypes.any,
};

export default RegisterContainer;
